// ヘッダーナビ
document.querySelectorAll('.mega-menu').forEach(menu => {
  const fadeDuration = 300; // フェードの時間 (ms)
  const interval = 20; // フレーム間隔 (ms)
  const step = interval / fadeDuration; // 1フレームでの透明度の変化量

  menu.addEventListener('toggle', () => {
    const content = menu.querySelector('.mega-menu__content');

    if (menu.open) {
      // 初期状態を隠したまま設定
      content.style.opacity = '0';
      content.style.display = 'block'; // 表示
      requestAnimationFrame(() => fade(content, true, step, interval));
    } else {
      fade(content, false, step, interval);
    }
  });

  function fade(element, fadeIn, step, interval) {
    let opacity = fadeIn ? 0 : 1; // 初期透明度
    const fade = setInterval(() => {
      opacity += fadeIn ? step : -step; // 透明度を増減
      element.style.opacity = opacity; // 透明度を更新

      if (opacity <= 0 || opacity >= 1) {
        clearInterval(fade); // フェード完了
        if (!fadeIn) element.style.display = 'none'; // フェードアウト時に非表示
      }
    }, interval);
  }
});

$(function(){
  const $term = $('.js-accordion-term');
  const $description = $('.js-accordion-description');
  $term.on('click', function () {
    $(this).siblings($description).slideToggle(300);
    $(this).toggleClass('is-open');
  });
});


$(function () {
    $('a[href^="#"]').click(function (e) {
      e.preventDefault(); // デフォルトの動作をキャンセル
      var speed = 500; // スクロールのスピード
      var href = $(this).attr('href'); // クリックされたリンクのhrefを取得
      var target = $(href); // ターゲットとなる要素を取得
      if (target.length) { // ターゲットが存在する場合のみ実行
        var position = target.offset().top; // ターゲットの位置を取得
        $('html, body').animate({ scrollTop: position }, speed, 'swing'); // スムーズスクロール
      }
    });
  });
